import { createSafeContext } from '@sgme/react';

export interface FailedPasteCell {
  fieldId: string;
  pastedValue: string;
  cellId: string;
}

export type BatchPasteDataContextValue = {
  pasteCellId?: string;
  setPasteCellId?: (cellId: string | undefined) => void;
  pastedData?: string;
  setPastedData?: (data: string | undefined) => void;
  pastedGridData?: Record<string, string>;
  setPastedGridData?: (data: Record<string, string> | undefined) => void;
  failedPasteCells?: FailedPasteCell[];
  setFailedPasteCells?: (cellIds: FailedPasteCell[] | undefined) => void;
};

export const [BatchPasteDataContextProvider, useBatchPastedDataContext] = createSafeContext<BatchPasteDataContextValue>(
  'BatchPasteDataContext',
  {},
);
